export default __webpack_public_path__ + "static/media/specicon.009f905c.png";